const TypesTestsEnum = {
    "VIEW": "VIEW",
    "TEST": "TEST"
}

export default TypesTestsEnum;